import React from "react";
import { getCurrentYear } from "../../../_utils";

const CopyRight = () => {
  return (
    <div className="copyright">
      <div className="pull-left">
        © {getCurrentYear()} <strong>amst.co.in</strong>. All rights reserved.
      </div>
      <div className="pull-right">
        <a
          href="https://amst.co.in/terms-of-use.html"
          target="_blank"
          rel="noopener noreferrer"
        >
          Terms of use
        </a>{" "}
        /{" "}
        <a
          href="https://amst.co.in/privacy-policy.html"
          target="_blank"
          rel="noopener noreferrer"
        >
          Privacy Policy
        </a>
      </div>
    </div>
  );
};

export default CopyRight;



// WEBPACK FOOTER //
// ./src/_components/Layout/CopyRight/index.js